import axios from "axios";
import { Student, StudentStatus } from "../students/api";

export interface BplStudentFilters {
  sessionId?: string;
  classId?: string;
  sectionId?: string;
  status?: StudentStatus | "";
  search?: string;
}

export const bplStudentsApi = {
  getAll: async (params?: {
    page?: number;
    limit?: number;
    filters?: BplStudentFilters;
  }) => {
    const query: any = {
      page: params?.page,
      limit: params?.limit,
    };

    if (params?.filters) {
      if (params.filters.sessionId) query.sessionId = params.filters.sessionId;
      if (params.filters.classId) query.classId = params.filters.classId;
      if (params.filters.sectionId) query.sectionId = params.filters.sectionId;
      if (params.filters.status) query.status = params.filters.status;
      if (params.filters.search) query.search = params.filters.search;
    }

    const response = await axios.get("/scholar-register/bpl-students", {
      params: query,
    });
    return response.data as {
      data: Student[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    };
  },

  getById: async (id: string) => {
    const response = await axios.get(`/scholar-register/bpl-students/${id}`);
    return response.data as Student;
  },
};
